document.addEventListener('DOMContentLoaded', () => {
    const gapReason = document.getElementById('gapReason');
    const gapDuration = document.getElementById('gapDuration');
    const gapActivity = document.getElementById('gapActivity');
    const generateBtn = document.getElementById('generateBtn');
    const templatesContainer = document.getElementById('templatesContainer');
    
    const coverLetterText = document.getElementById('coverLetterText');
    const interviewText = document.getElementById('interviewText');
    const resumeText = document.getElementById('resumeText');

    function generateTemplates() {
        const reason = gapReason.value;
        const duration = gapDuration.value.trim() || 'some time';
        const activity = gapActivity.value.trim();
        
        let cl = "";
        let iv = "";
        let rs = "";
        
        const activityPhrase = activity ? ` During this period, I ${activity}, which kept my skills sharp and prepared me for my next role.` : '';
        const activityPhraseInterview = activity ? ` In that time, I ${activity}, so I've been staying engaged.` : '';
        const activityPhraseResume = activity ? ` • Actively engaged in: ${activity}.` : '';

        if (reason === 'layoff') {
            cl = `Like many others in the industry, my previous role was impacted by company-wide restructuring, resulting in a gap of ${duration}.${activityPhrase} I am now fully ready to bring my expertise to a new team and am particularly excited about the [Job Title] role at [Company Name].`;
            
            iv = `My former company went through a restructuring that unfortunately impacted my department. I've taken the last ${duration} to intentionally search for the right fit.${activityPhraseInterview} I'm fully recharged and eager to hit the ground running here.`;
            
            rs = `Planned Career Break (${duration})${activityPhraseResume}\n• Ready to leverage previous success in a new, challenging environment.`;
            
        } else if (reason === 'medical') {
            cl = `I took ${duration} away from my career to focus on a personal health matter. That matter is now fully resolved.${activityPhrase} I am excited to return to the workforce and contribute to [Company Name]'s goals.`;
            
            iv = `I needed to take ${duration} to deal with a medical issue. The good news is that it is completely resolved and behind me now.${activityPhraseInterview} I am 100% ready to return to work and am very excited about this opportunity.`;
            
            rs = `Health/Personal Leave (${duration})${activityPhraseResume}\n• Leave concluded; fully cleared and eager to resume professional career.`;
            
        } else if (reason === 'caregiving') {
            cl = `Over the past ${duration}, I paused my career to act as a primary caregiver for a family member. My family situation has since stabilized, and I am fully prepared to resume my career.${activityPhrase} I am highly motivated to bring my skills to the [Job Title] position.`;
            
            iv = `I took ${duration} off to care for a family member. It was the right decision for my family at the time, but that situation is now resolved and I have full-time care in place.${activityPhraseInterview} I'm really looking forward to diving back into my career.`;
            
            rs = `Full-time Caregiver (${duration})${activityPhraseResume}\n• Successfully managed complex household logistics and schedules.\n• Fully transitioned back to professional availability.`;
            
        } else if (reason === 'education') {
            cl = `For the past ${duration}, I chose to step away from full-time employment to focus on advancing my education and upskilling.${activityPhrase} With these new qualifications, I am excited to apply my updated skill set to the challenges at [Company Name].`;
            
            iv = `I deliberately took ${duration} off to focus on my professional development and education.${activityPhraseInterview} I wanted to level up my skills, and now that I've completed that goal, I am eager to apply what I've learned in this role.`;
            
            rs = `Continuing Education (${duration})${activityPhraseResume}\n• Dedicated time to intensive upskilling and professional development.`;
            
        } else if (reason === 'sabbatical') {
            cl = `After a sustained period of career growth, I took a planned sabbatical of ${duration} for personal travel and development.${activityPhrase} I am returning to the workforce energized, focused, and ready to tackle the [Job Title] role.`;
            
            iv = `I had the opportunity to take a planned sabbatical for ${duration} to travel and focus on personal goals.${activityPhraseInterview} It was a fantastic experience that left me completely recharged, and I am now very excited to return to my career with fresh perspective.`;
            
            rs = `Planned Sabbatical (${duration})${activityPhraseResume}\n• Took intentional time for personal growth and global travel.\n• Returning highly motivated and focused on next career milestone.`;
            
        } else if (reason === 'relocation') {
            cl = `I recently relocated to the area, which accounts for the ${duration} gap in my employment.${activityPhrase} I am now fully settled and actively seeking a long-term role where I can immediately add value.`;
            
            iv = `I recently relocated to this city, so I took ${duration} to manage the move and get my family settled.${activityPhraseInterview} We are completely unpacked and settled now, and I'm ready to focus entirely on my next professional chapter.`;
            
            rs = `Relocation (${duration})${activityPhraseResume}\n• Managed logistics of cross-country relocation and settlement.`;
        }
        
        coverLetterText.textContent = cl;
        interviewText.textContent = iv;
        resumeText.textContent = rs;
        
        templatesContainer.style.display = 'block';
        
        // Scroll to results
        setTimeout(() => {
            templatesContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }

    generateBtn.addEventListener('click', generateTemplates);
});
